<template>
  <div style="width: min-content">
    <v-hover v-slot="{ hover }">
      <div style="position: relative; width: 100%; height: 100%">
        <v-img
          @click="item ? openItem() : upload()"
          class="cursor-pointer rounded"
          :src="sourceItem ?? '/images/not-found.png'"
          :max-height="height"
          :width="width"
          :height="height"
          :aspect-ratio="aspectRatio"
          :max-width="width"
        >
          <div
            v-if="hover"
            class="image-box d-flex align-center justify-center"
          >
            <v-icon
              color="white"
              :size="width > height ? height / 3 : width / 3"
            >
              {{ item ? 'mdi-eye' : readOnly ? '' : 'mdi-pen' }}
            </v-icon>
          </div>
        </v-img>
        <div style="z-index: 100; position: absolute; top: 10px; right: 10px">
          <v-icon
            v-if="hover && !disableEdit && item"
            :size="25"
            color="white"
            @click="upload"
          >
            mdi-pen
          </v-icon>
          <v-icon
            v-if="hover && canDelete && !readOnly"
            :size="25"
            class="ml-3"
            color="white"
            @click="$emit('delete')"
          >
            mdi-delete
          </v-icon>
        </div>
      </div>
    </v-hover>
    <v-dialog
      v-model="showVideoDialog"
      max-width="700px"
    >
      <v-card
        ><VideoPlayer
          :src="item"
          :poster="videoThumbnail"
      /></v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { MediaType } from '@/airModels/types/mediaTypes.js'
  import VideoPlayer from './VideoPlayer.vue'

  export default {
    name: 'MediaItem',
    props: {
      item: {
        type: String,
        required: false
      },
      videoThumbnail: {
        type: String,
        required: false
      },
      mediaType: {
        type: Number,
        required: true
      },
      width: {
        type: [Number, String],
        default: 140
      },
      height: {
        type: [Number, String],
        default: 140
      },
      aspectRatio: {
        type: [Number, String],
        default: 1
      },
      disableEdit: Boolean,
      canDelete: Boolean,
      readOnly: Boolean
    },
    components: { VideoPlayer },

    data: () => {
      return {
        showVideoDialog: false
      }
    },
    computed: {
      sourceItem() {
        if (this.mediaType === MediaType.VIDEO) {
          return this.videoThumbnail
        } else {
          return this.item
        }
      },
      styles() {
        return {
          border: '1px solid #c5c5c5',
          width: this.addUnit(this.width),
          height: this.addUnit(this.height),
          maxWidth: this.addUnit(this.maxWidth),
          aspectRatio: this.aspectRatio || undefined
        }
      }
    },
    methods: {
      addUnit(value) {
        if (typeof value === 'number') return value + 'px'
        return value
      },
      openItem() {
        if (this.mediaType == MediaType.IMAGE) {
          this.openImage()
        } else {
          this.showVideoDialog = true
        }
      },
      openImage() {
        this.$eventBus.$emit('setImages', [{ image: this.item }])
        this.$eventBus.$emit('setIndex', 0)
      },
      upload() {
        if (this.readOnly) return
        const input = document.createElement('input')
        input.setAttribute('hidden', 'true')
        input.setAttribute('type', 'file')
        input.setAttribute('id', 'upload-media')
        input.setAttribute('accept', 'image/jpeg, image/png, video/mp4, video/quicktime')
        document.body.appendChild(input)
        input.click()
        input.addEventListener('change', e => {
          const input = e.target
          if (input && input.files && input.files.length) {
            const file = input.files[0]
            this.$emit('input', file)
            input.remove()
          } else if (input) {
            input.remove()
          }
        })
      }
    }
  }
</script>
